import React, { useState, useEffect } from "react";
import Alert from "../common/Alert";
import { useSelector, useDispatch } from "react-redux";
import SessionHelper from "../../helpers/SessionHelper";
import _ from "lodash";
import FluentdHelper from "../../helpers/FluentdHelper";
import {
  selectPolygon,
  saveFieldPopUpData,
  updateFieldPopUpData,
  clearSelectedField,
  addedField,
  formType,
  setInitialFarms,
  setInitialBusiness,
} from "../../configurations/redux-configurations/actions/fieldAction";
import {
  Popover,
  Button,
  OverlayTrigger,
  Form,
  Row,
  Col,
  Table,
  Spinner,
  CloseButton,
} from "react-bootstrap";
import {
  LOGERROR,
  AVAILABLE,
  REGISTERED,
  DANGER,
  SHOW_BUSINESS,
  SHOW_FARM,
  SHOW_FIELD,
  CLAIM_IDS,
  EMPTY,
} from "../../configurations/Constants";
import {
  ERROR_WHILE_CLAIMING_FIELD,
  FARM_NAME_CANNOT_BE_EMPTY,
  BUSINESS_NAME_CANNOT_BE_EMPTY,
  FIELD_FARM_BUSINESS_CANNOT_BE_EMPTY,
  ONE_WELL_SHOULD_BE_ACTIVE,
  NO_ACTIVE_POLYGON,
  ERROR_WHILE_UPDATING_FIELD,
  ERROR_WHILE_REGISTERING_FIELD,
  ENTER_VALUE,
  INVALID_VALUE,
  SELECT_BUSINESS,
  ENTER_FARM_NAME,
  FARM_NAME_EXIST,
  ENTER_BUSINESS_NAME,
  BUSINESS_NAME_EXIST,
  SELECT_FARM,
  ENTER_FIELD_NAME,
  ADD_UPTO_25_FIELDS,
  NAME_EXIST,
} from "../../configurations/MessageConstants";
import StorageHelper from "../../helpers/StorageHelper";
import UserService from "../../api-service/UserService";
import FieldWells from "./FieldWells";
import { StatusCodes } from "../../configurations/status-codes";

function AddField(props) {
  const dispatch = useDispatch();
  const ActivePolygon = useSelector((state) => state.field.activePolygon);
  const AddedFields = useSelector((state) => state.field.addedFields);
  const FarmsValue = useSelector((state) => state.field.farms);
  const BusinessValue = useSelector((state) => state.field.business);
  const DisplayForm = useSelector((state) => state.field.form_display);
  const loggedInUser = useSelector((state) => state.user.loggedInUser);
  const registeredUser = useSelector((state) => state.user.registeredUser);

  const [businessValidated, setBusinessValidated] = useState(false);
  const [farmValidated, setFarmValidated] = useState(false);
  const [validated, setValidated] = useState(false);
  const [fieldName, setFieldName] = useState(EMPTY);
  const [farmName, setFarmName] = useState(EMPTY);
  const [businessName, setBusinessName] = useState(EMPTY);
  const [btnAddFieldClick, setBtnAddFieldClick] = useState(false);
  const [well_details, setWell_details] = useState([]);
  const [WellDetailsChanged, setWellDetailsChanged] = useState(false);
  const [display_form, setDisplay_form] = useState(EMPTY);
  const [fieldError, setFieldError] = useState(EMPTY);
  const [errorMessage, setErrorMessage] = useState(EMPTY);
  const [index, setIndex] = useState(EMPTY);
  const [surfaceWaterIrrigation, setSurfaceWaterIrrigation] = useState(false);
  const [editField, setEditField] = useState(false);
  const [editRegisteredField, setEditRegisteredField] = useState(false);
  const [fieldNameError, setFieldNameError] = useState(false);
  const [groundWaterPercentage, setGroundWaterPercentage] = useState(EMPTY);
  const [surfaceWaterPercentage, setSurfaceWaterPercentage] = useState(EMPTY);
  const [regFieldIrrigUnitId, setRegFieldIrrigUnitId] = useState(EMPTY);
  const [regFieldGuid, setRegFieldGuid] = useState(EMPTY);
  const [regFieldId, setRegFieldId] = useState(EMPTY);
  const [newFarmName, setNewFarmName] = useState(EMPTY);
  const [newBusinessName, setNewBusinessName] = useState(EMPTY);
  const [btnClaimEnabled, setBtnClaimEnabled] = useState(false);
  const [irrig_unit_Id, setIrrig_unit_Id] = useState(EMPTY);
  const [farms, setFarms] = useState(FarmsValue);
  const [business, setBusiness] = useState(BusinessValue);

  const [invalidFarmNameError, setInvalidFarmNameError] = useState(false);
  const [farmError, setFarmError] = useState(false);
  const [btnAddFarmClick, setBtnAddFarmClick] = useState(false);
  const [businessError, setBusinessError] = useState(false);
  const [invalidBusinessNameError, setInvalidBusinessNameError] =
    useState(false);
  const [btnAddBusinessClick, setBtnAddBusinessClick] = useState(false);

  useEffect(() => {
    setWellDetailsChanged(false);
    setFarmName(props.farmName);
    setFieldName(props.fieldName);
    setSurfaceWaterIrrigation(props.surfaceWaterIrrigation);
    setGroundWaterPercentage(props.groundWaterPercentage);
    setSurfaceWaterPercentage(props.surfaceWaterPercentage);
  }, []);

  useEffect(() => {
    setDisplay_form(DisplayForm);
    setWell_details(
      well_details && WellDetailsChanged ? well_details : props.well_details
    );
    setEditField(props.editField);
    setBtnClaimEnabled(props.btnClaimEnabled);
    setEditRegisteredField(props.editRegisteredField);
    setRegFieldIrrigUnitId(props.regFieldIrrigUnitId);
    setRegFieldGuid(props.regFieldGuid);
    setRegFieldId(props.regFieldId);
    setIndex(props.index);
    setIrrig_unit_Id(props.irrig_unit_Id);
  }, [
    DisplayForm,
    props.well_details,
    props.editField,
    props.btnClaimEnabled,
    props.editRegisteredField,
    props.regFieldIrrigUnitId,
    props.regFieldGuid,
    props.regFieldId,
    props.index,
    props.irrig_unit_Id,
  ]);

  const hideShowPopup = async (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (DisplayForm === SHOW_BUSINESS) {
      setNewBusinessName(EMPTY);
      setGroundWaterPercentage(EMPTY);
      setSurfaceWaterPercentage(EMPTY);
      setFieldError(false);
      setErrorMessage(EMPTY);
      setBusinessValidated(false);
      setFarmValidated(false);
      dispatch(formType(SHOW_FARM));
    } else if (DisplayForm === SHOW_FARM) {
      dispatch(formType(SHOW_FIELD));
      setNewFarmName(EMPTY);
      setBusinessName(EMPTY);
      setGroundWaterPercentage(EMPTY);
      setSurfaceWaterPercentage(EMPTY);
      setFieldError(false);
      setErrorMessage(EMPTY);
      setBusinessValidated(false);
      setFarmValidated(false);
    } else if (DisplayForm === SHOW_FIELD) {
      if (editField === false) {
        props.removeWells();
        if (ActivePolygon) {
          let layer = props.getLayerByIrrigUnitId(
            ActivePolygon.properties.irrig_unit_id
          );
          layer.setAttribute("fill", btnClaimEnabled ? REGISTERED : AVAILABLE);
        }
        dispatch(selectPolygon(null));
      }
      if (editRegisteredField === false) {
        props.removeWells();
        dispatch(selectPolygon(null));
      }
      props.resetEditFieldDetails();
      props.hidePopup();
      setTimeout(() => {
        setGroundWaterPercentage(EMPTY);
        setSurfaceWaterPercentage(EMPTY);
      }, 200);
    }
  };

  const onCheckboxChecked = (e) => {
    setSurfaceWaterIrrigation(!surfaceWaterIrrigation);
    setGroundWaterPercentage(EMPTY);
    setSurfaceWaterPercentage(EMPTY);
  };

  const surfaceWaterChange = (e) => {
    let surfaceWaterPercentageValue = e.target.value;
    if (surfaceWaterPercentageValue > 100) {
      surfaceWaterPercentageValue = 100;
    }
    setSurfaceWaterPercentage(surfaceWaterPercentageValue);
    setGroundWaterPercentage(100 - surfaceWaterPercentageValue);
  };

  const hideFieldLimitPopup = async (event) => {
    event.preventDefault();
    props.hidePopup();
    props.doPopupVisibleFalse();
    setTimeout(() => {
      setDisplay_form(SHOW_FIELD);
    }, 1000);
  };

  const updateWellDetails = (updatedWellData, idx) => {
    let newwell_details = well_details.map((well, sidx) => {
      if (idx !== sidx) return well;
      return updatedWellData;
    });
    setWellDetailsChanged(true);
    setWell_details(newwell_details);
  };

  const handle_farm_change = (e) => {
    setFarmName(e.target.value);
  };

  const add_new_farm = () => {
    dispatch(formType(SHOW_FARM));
    setFarmName(EMPTY);
    setBusinessName(EMPTY);
  };

  const add_new_business = () => {
    dispatch(formType(SHOW_BUSINESS));
    setBusinessName(EMPTY);
  };

  const handle_business_change = (e) => {
    setBusinessName(e.target.value);
  };

  const closeAlert = () => {
    setFieldError(false);
    setFarmError(false);
    setBusinessError(false);
  };

  const onChange = (e) => {
    if (e.target.name === "fieldName") setFieldName(e.target.value);
    else if (e.target.name === "newFarmName") setNewFarmName(e.target.value);
    else if (e.target.name === "newBusinessName")
      setNewBusinessName(e.target.value);
  };

  const groundWaterChange = (e) => {
    let groundWaterPercentageValue = e.target.value;
    if (groundWaterPercentageValue > 100) {
      groundWaterPercentageValue = 100;
    }
    setGroundWaterPercentage(groundWaterPercentageValue);
    setSurfaceWaterPercentage(100 - groundWaterPercentageValue);
  };

  const addedFieldCheck = (addedFields, fieldName) => {
    for (let i = 0; i < addedFields.length; i++) {
      if (editField === true) {
        if (
          addedFields[i].fieldName.trim().toLowerCase() ===
            fieldName.trim().toLowerCase() &&
          addedFields[i].irrig_unit_Id !== irrig_unit_Id
        ) {
          setValidated(true);
          setBtnAddFieldClick(false);
          setFieldNameError(true);
          return false;
        }
      } else {
        if (
          addedFields[i].fieldName.trim().toLowerCase() ===
          fieldName.trim().toLowerCase()
        ) {
          setValidated(true);
          setBtnAddFieldClick(false);
          setFieldNameError(true);
          return false;
        }
      }
    }
  };

  const handleEmptyStringsInJson = (object) => {
    let jsonString = JSON.stringify(object);
    let myjson = jsonString.replace(/" "|EMPTY/g, 0);
    return JSON.parse(myjson);
  };

  const userClaimCheck = (fieldName) => {
    for (let i = 0; i < props.userClaimedFields.data.length; i++) {
      if (
        props.userClaimedFields.data[i].claim_field[0].field_name
          .trim()
          .toLowerCase() === fieldName.trim().toLowerCase()
      ) {
        setValidated(true);
        setBtnAddFieldClick(false);
        setFieldNameError(true);
        return false;
      }
    }
  };

  const handleAddClaim = async () => {
    await SessionHelper.handleRefreshToken();
    let i = 0;
    dispatch(clearSelectedField());
    let farmBusiness = businessName;
    for (i = 0; i < farms.length; i++) {
      if (farms[i].farmName.trim() === farmName) {
        farmBusiness = farms[i].businessName;
        break;
      }
    }

    if (ActivePolygon && Object.keys(ActivePolygon).length > 0) {
      let wells = [];
      let fieldId = EMPTY;
      if (
        props.registeredFields &&
        Object.keys(props.registeredFields).length > 0
      ) {
        props.registeredFields.data.forEach((field) => {
          if (ActivePolygon.properties.irrig_unit_id === field.irrig_unit_id) {
            fieldId = field.field_id;
          }
        });
      }

      for (i = 0; i < well_details.length; i++) {
        let well = well_details[i];
        wells.push({
          well_id: well.id,
          well_id: well.well_id,
          pump_rate: well.gpm,
          updated_pump_rate:
            well.ugpm.toString().trim() === EMPTY
              ? well.gpm
              : parseInt(well.ugpm),
          active: well.activeWell,
          isElectricWell: well.isElectricWell,
        });
      }
      let payload = {
        field_id: fieldId,
        field_name: fieldName,
        farm_name: farmName,
        business_name: farmBusiness,
        well_data: wells,
      };
      payload = handleEmptyStringsInJson(payload);
      let user_email = loggedInUser || registeredUser;

      try {
        await UserService.claimRegisteredField(payload);
        props.hidePopup();
        dispatch(selectPolygon(null));
        dispatch(setInitialBusiness(business));
        dispatch(setInitialFarms(farms));
        let claim_ids = StorageHelper.getItem(CLAIM_IDS)
          ? JSON.parse(StorageHelper.getItem(CLAIM_IDS))
          : [];
        claim_ids.push(ActivePolygon.properties.irrig_unit_id);
        StorageHelper.setItem(CLAIM_IDS, JSON.stringify(claim_ids));
        window.location.reload();
      } catch (error) {
        let responseData = error.response.data;
        console.error(ERROR_WHILE_CLAIMING_FIELD, error);
        setBtnAddFieldClick(false);
        setFieldError(true);
        setErrorMessage(
          error.response.status === StatusCodes.BAD_REQUEST
            ? responseData.message
            : ERROR_WHILE_CLAIMING_FIELD
        );
        FluentdHelper.logEvent(
          ERROR_WHILE_CLAIMING_FIELD,
          "addField_handleAddClaim",
          user_email,
          {
            response:
              error.response.status === StatusCodes.BAD_REQUEST
                ? responseData
                : error,
          },
          LOGERROR
        );
      }
    }
  };

  const handle_add_farm = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setBtnAddFarmClick(true);

    let farmsValue = farms;
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      setFarmValidated(true);
      setBtnAddFarmClick(false);
      return false;
    } else {
      dispatch(formType(SHOW_FIELD));
      if (newFarmName.trim() === EMPTY) {
        setFarmValidated(true);
        setBtnAddFarmClick(false);
        setFarmError(true);
        setErrorMessage(FARM_NAME_CANNOT_BE_EMPTY);
        return false;
      }
      for (let i = 0; i < farmsValue.length; i++) {
        if (
          newFarmName.trim().toLowerCase() ===
          farmsValue[i].farmName.trim().toLowerCase()
        ) {
          setFarmValidated(true);
          setInvalidFarmNameError(true);
          setBtnAddFarmClick(false);
          return false;
        }
      }
    }
    farmsValue.push({
      farmName: newFarmName,
      businessName: businessName,
    });
    dispatch(setInitialFarms(farmsValue));
    setDisplay_form(SHOW_FIELD);
    setFarms(farmsValue);
    setNewFarmName(EMPTY);
    setBusinessName(EMPTY);
    setFarmName(newFarmName);
    setInvalidFarmNameError(false);
    setBtnAddFarmClick(false);
  };

  const handle_add_business = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setBtnAddBusinessClick(true);
    let businessValue = BusinessValue;
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      setBusinessValidated(true);
      setBtnAddBusinessClick(false);
      return false;
    } else {
      if (newBusinessName.trim() === EMPTY) {
        setBusinessValidated(true);
        setBtnAddBusinessClick(false);
        setBusinessError(true);
        setErrorMessage(BUSINESS_NAME_CANNOT_BE_EMPTY);
        return false;
      }

      for (let i = 0; i < businessValue.length; i++) {
        if (
          newBusinessName.trim().toLowerCase() ===
          businessValue[i].trim().toLowerCase()
        ) {
          setFarmValidated(true);
          setInvalidBusinessNameError(true);
          setBtnAddBusinessClick(false);
          return false;
        }
      }
    }
    businessValue.push(newBusinessName);

    setDisplay_form(SHOW_FARM);
    setBusiness(businessValue);
    setNewBusinessName(EMPTY);
    setBusinessName(newBusinessName);
    setInvalidBusinessNameError(false);
    setBtnAddBusinessClick(false);
    dispatch(setInitialBusiness(businessValue));
  };

  const userRegisteredFieldCheck = (fieldName) => {
    for (let i = 0; i < props.allUserRegisteredFields.data.length; i++) {
      if (
        props.allUserRegisteredFields.data[i].field_name
          .trim()
          .toLowerCase() === fieldName.trim().toLowerCase() &&
        regFieldIrrigUnitId !==
          props.allUserRegisteredFields.data[i].irrig_unit_id
      ) {
        setValidated(true);
        setBtnAddFieldClick(false);
        setFieldNameError(true);
        return false;
      }
    }
  };

  const handleOnsubmit = async (event) => {
    try {
      let farmNameValue = farmName;
      let fieldNameValue = fieldName;
      let businessNameValue = businessName;
      event.preventDefault();
      event.stopPropagation();
      await SessionHelper.handleRefreshToken();

      setBtnAddFieldClick(true);
      setFieldNameError(false);
      let getBusinessName = _.find(farms, { farmName: farmNameValue.trim() });
      if (getBusinessName) {
        businessNameValue = getBusinessName.businessName;
      }

      if (
        businessNameValue.trim() === EMPTY ||
        farmNameValue.trim() === EMPTY ||
        fieldNameValue.trim() === EMPTY
      ) {
        setBtnAddFieldClick(false);
        setFieldError(true);
        setErrorMessage(FIELD_FARM_BUSINESS_CANNOT_BE_EMPTY);
        return false;
      } else {
        setFieldError(false);
        setErrorMessage(EMPTY);
      }

      let registeredFields = [];
      if (
        props.registeredFields &&
        Object.keys(props.registeredFields).length > 0
      ) {
        props.registeredFields.data.forEach((field) => {
          registeredFields.push(field.irrig_unit_id);
        });
      }

      const form = event.target;
      const addedFields = AddedFields;
      if (form.checkValidity() === false) {
        setValidated(true);
        setBtnAddFieldClick(false);
        return false;
      } else {
        let addedFieldCheckValue = addedFieldCheck(addedFields, fieldNameValue);
        if (addedFieldCheckValue === false) {
          return false;
        }
        if (
          props.allUserRegisteredFields &&
          Object.keys(props.allUserRegisteredFields).length > 0
        ) {
          let userRegisteredFieldCheckValue =
            userRegisteredFieldCheck(fieldNameValue);
          if (userRegisteredFieldCheckValue === false) {
            return false;
          }
        }
        if (
          props.userClaimedFields &&
          Object.keys(props.userClaimedFields).length > 0
        ) {
          let userClaimCheckValue = userClaimCheck(fieldNameValue);
          if (userClaimCheckValue === false) {
            return false;
          }
        }
        let activeWellCount = well_details.filter(function (well) {
          if (well.activeWell === true) {
            return well;
          }
          return null;
        });
        if (activeWellCount.length === 0) {
          setValidated(true);
          setBtnAddFieldClick(false);
          setFieldError(true);
          setErrorMessage(ONE_WELL_SHOULD_BE_ACTIVE);
          return false;
        }
      }
      if (editField === true) {
        dispatch(
          updateFieldPopUpData(
            fieldNameValue,
            farmNameValue,
            businessNameValue,
            surfaceWaterIrrigation,
            well_details,
            irrig_unit_Id,
            farms,
            business,
            surfaceWaterPercentage,
            groundWaterPercentage,
            index
          )
        );

        props.hidePopup();
        dispatch(selectPolygon(null));
        props.displayPanel();
        props.resetEditFieldDetails();
        return false;
      } else if (editRegisteredField === true) {
        updateRegisteredFieldPopUpData(
          fieldNameValue,
          farmNameValue,
          businessNameValue,
          surfaceWaterIrrigation,
          well_details,
          surfaceWaterPercentage,
          groundWaterPercentage,
          regFieldGuid,
          regFieldId,
          regFieldIrrigUnitId
        );
        return false;
      }

      if (ActivePolygon && Object.keys(ActivePolygon).length > 0) {
        if (registeredFields.includes(ActivePolygon.properties.irrig_unit_id)) {
          handleAddClaim();
        } else {
          setBtnAddFieldClick(true);
          dispatch(
            saveFieldPopUpData(
              fieldNameValue,
              farmNameValue,
              businessNameValue,
              surfaceWaterIrrigation,
              well_details,
              ActivePolygon.properties.irrig_unit_id,
              farms,
              business,
              surfaceWaterPercentage,
              groundWaterPercentage
            )
          );
          props.hidePopup();
          dispatch(selectPolygon(null));
          dispatch(addedField(true));
          props.displayPanel();
          setFieldName(EMPTY);
          setFarmName(EMPTY);
          setBtnAddFieldClick(false);
          props.doPopupVisibleFalse();
        }
      } else {
        setBtnAddFieldClick(false);
        setFieldError(true);
        setErrorMessage(NO_ACTIVE_POLYGON);
      }
    } catch (error) {
      let user_email = loggedInUser || registeredUser;
      FluentdHelper.logEvent(
        ERROR_WHILE_REGISTERING_FIELD,
        "addField_handleOnsubmit",
        user_email,
        {
          response: error,
        },
        LOGERROR
      );
    }
  };

  const updateRegisteredFieldPopUpData = async (
    fieldName,
    farmName,
    businessName,
    surfaceWaterIrrigation,
    well_details,
    surfaceWaterPercentage,
    groundWaterPercentage,
    regFieldGuid,
    regFieldId,
    regFieldIrrigUnitId
  ) => {
    let wells = [];
    for (let i = 0; i < well_details.length; i++) {
      let well = well_details[i];
      let updatedgpm = well.ugpm;
      if (well.ugpm === EMPTY) {
        updatedgpm = well.gpm;
      }
      wells.push({
        well_id: well.well_id,
        pump_rate: well.gpm,
        updated_pump_rate: parseInt(updatedgpm),
        active: well.activeWell,
        isElectricWell: well.isElectricWell,
      });
    }

    let payload = {};
    let user_email = loggedInUser || registeredUser;
    try {
      payload = {
        field_id: regFieldId,
        field_name: fieldName,
        irrig_unit_id: regFieldIrrigUnitId,
        business_name: businessName,
        farm_name: farmName,
        well_data: wells,
        groundWaterPercentage: parseInt(groundWaterPercentage) || 0,
        surfaceWaterPercentage: parseInt(surfaceWaterPercentage) || 0,
      };

      await UserService.updateRegisteredField(payload);
      dispatch(selectPolygon(null));
      props.removeWells();
      props.doPopupVisibleFalse();
      window.location.reload();
    } catch (error) {
      let responseData = error.response.data;
      console.error(ERROR_WHILE_UPDATING_FIELD, error);
      setBtnAddFieldClick(false);
      setFieldError(true);
      setErrorMessage(
        error.response.status === StatusCodes.BAD_REQUEST
          ? responseData.message
          : ERROR_WHILE_UPDATING_FIELD
      );
      FluentdHelper.logEvent(
        ERROR_WHILE_UPDATING_FIELD,
        "addField_updateRegisteredFieldPopUpData",
        user_email,
        {
          response:
            error.response.status === StatusCodes.BAD_REQUEST
              ? responseData
              : error,
        },
        LOGERROR
      );
    }
  };

  const { showPopover, acres, isWellShown } = props;
  let i = 0;
  let businessProps = BusinessValue;
  let farmsProps = FarmsValue;
  let addedFields = [];
  let farm_list = [];
  let business_list = [];

  _.map(AddedFields, function (field) {
    addedFields.push(field.irrig_unit_id);
  });
  let parser = new DOMParser();
  if (showPopover === true) {
    farm_list = [];
    business_list = [];

    for (i = 0; i < farmsProps.length; i++) {
      const farmNameDoc = parser.parseFromString(
        farmsProps[i].farmName,
        "text/html"
      );

      farm_list.push(
        <option key={i} value={farmNameDoc.body.innerText}>
          {farmNameDoc.body.innerText}
        </option>
      );
    }

    for (i = 0; i < businessProps.length; i++) {
      const businessNameDoc = parser.parseFromString(
        businessProps[i],
        "text/html"
      );
      business_list.push(
        <option key={i} value={businessNameDoc.body.innerText}>
          {businessNameDoc.body.innerText}
        </option>
      );
    }
  }

  return (
    <div>
      <div
        id="fieldLimit"
        className={display_form === "field_limit" ? EMPTY : "hide-form"}
      >
        <Popover.Header>Warning</Popover.Header>
        <CloseButton
          className="close"
          variant="white"
          onClick={(event) => hideFieldLimitPopup(event)}
        />
        <Popover.Body>
          <Form>
            <Row>
              <Form.Group as={Col} md="12">
                <Form.Label className="warningLabel">
                  <br />
                  {ADD_UPTO_25_FIELDS}
                </Form.Label>
              </Form.Group>
              <Form.Group as={Col} md="12" className="mt-12">
                <Button
                  className="mt-2"
                  onClick={(e) => hideFieldLimitPopup(e)}
                >
                  OK{" "}
                </Button>
              </Form.Group>
            </Row>
          </Form>
        </Popover.Body>
      </div>
      <div
        id="add_field"
        className={display_form === SHOW_FIELD ? EMPTY : "hide-form"}
      >
        <Popover.Header>
          {btnClaimEnabled
            ? "Claim Field"
            : editField || editRegisteredField
            ? "Edit Field"
            : "Add Field"}
        </Popover.Header>
        <CloseButton
          className="close"
          variant="white"
          aria-hidden="true"
          onClick={(event) => {
            hideShowPopup(event);
          }}
        />
        <Popover.Body>
          {fieldError ? (
            <Alert
              key="messageAlert"
              variant={DANGER}
              closeAlert={(e) => closeAlert(e)}
              alertMessage={errorMessage}
              dismissible
            />
          ) : (
            EMPTY
          )}
          <Form
            key="popoverForm"
            noValidate
            validated={validated}
            onSubmit={(e) => {
              e.persist();
              handleOnsubmit(e);
            }}
          >
            <div className="well-data">
              <Row>
                <Form.Group as={Col} controlId="validationFieldName">
                  <Form.Label>
                    Field Name<span>*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    maxLength="40"
                    name="fieldName"
                    value={fieldName}
                    onChange={onChange}
                    required
                    className={
                      fieldNameError ? "is-invalid invalidcontrol" : EMPTY
                    }
                  />
                  <Form.Control.Feedback type="invalid">
                    {fieldName === EMPTY ? ENTER_FIELD_NAME : NAME_EXIST}
                  </Form.Control.Feedback>
                </Form.Group>
                <Form.Group as={Col} controlId="validationFarmName">
                  <Form.Label>
                    Farm Name<span>*</span>
                  </Form.Label>
                  <Form.Select
                    required
                    onChange={handle_farm_change}
                    value={farmName}
                  >
                    <option value={EMPTY}>-- Select a Farm --</option>
                    {farm_list}
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    {SELECT_FARM}
                  </Form.Control.Feedback>
                </Form.Group>
                <Col className="col-1 ps-1">
                  <i
                    className="fa fa-plus-circle add-farm-business-registration-btn"
                    onClick={add_new_farm}
                  />
                </Col>
              </Row>
              <Row className="mt-2">
                <h4 className="mt-2 col" xs={8}>
                  Well(s)
                  <OverlayTrigger
                    trigger="click"
                    rootClose
                    placement="bottom"
                    overlay={
                      <Popover id="info-popover">
                        <Popover.Body>
                          <p>
                            <b>Active Button:</b> For any wells listed that are
                            not utilized to irrigate the Field, please de-select
                            the “Active” button.
                          </p>
                          <p>
                            <b>Electric Button:</b> For any wells listed that
                            are not powered by electricity (electric smart
                            meter), please de-select the “Smart Meter” button.
                          </p>
                          <p>
                            <b>GPM:</b> For all active wells, please note the
                            pump rate listed in the “Listed GPM” box. If the
                            “Listed GPM” is inaccurate, please update the
                            correct pump rate in the “Updated GPM” box.
                          </p>
                        </Popover.Body>
                      </Popover>
                    }
                  >
                    <Button
                      variant="secondary"
                      className="info-button fa fa-info-circle"
                    ></Button>
                  </OverlayTrigger>
                </h4>
                <div className="field-acres col" xs={4}>
                  <b>Certified Acres</b>: {acres}
                </div>
              </Row>
              <p>
                The Well(s) numbered below correspond to the location of the
                same number on the map.
              </p>
              <Table className="table-responsive">
                <thead>
                  <tr>
                    <th width="10%" />
                    <th width="10%">Active</th>
                    <th width="20%">Electric </th>
                    <th width="30%">Listed GPM</th>
                    <th width="30%">Updated GPM</th>
                  </tr>
                </thead>
                <tbody>
                  {/* for showing well details in panel */}
                  {isWellShown &&
                    well_details.map((well, index) => (
                      <FieldWells
                        well={well}
                        index={index}
                        key={index}
                        updateWellDetails={updateWellDetails}
                      />
                    ))}
                </tbody>
              </Table>
              <h4 className="mt-3">Surface Water Irrigation</h4>
              <Form.Check
                className="popover-label"
                checked={surfaceWaterIrrigation}
                onChange={(e) => onCheckboxChecked()}
                label="If the selected Field utilizes Surface Water Irrigation, please check the box and indicate the approximate irrigation from Surface Water and Ground Water (as a percentage)."
                id="watersurface"
              />
              {surfaceWaterIrrigation && (
                <div className="surface-water">
                  <p className="mt-2">
                    Enter the percentage of surface water irrigation on this
                    field
                  </p>
                  <Row>
                    <Form.Group
                      as={Col}
                      md="3"
                      controlId="validationsurfaceper"
                    >
                      <Form.Label>Surface Water %</Form.Label>
                      <Form.Control
                        type="text"
                        style={{ width: "80px" }}
                        onChange={surfaceWaterChange}
                        name="surfaceWaterPercentage"
                        value={surfaceWaterPercentage}
                        maxLength="3"
                        pattern="[\d]{1,3}"
                        required
                        className="w-100"
                      />
                      <Form.Control.Feedback type="invalid">
                        {surfaceWaterPercentage === EMPTY
                          ? ENTER_VALUE
                          : INVALID_VALUE}
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group as={Col} md="3" controlId="validationgroundper">
                      <Form.Label>Ground Water %</Form.Label>
                      <Form.Control
                        type="text"
                        onChange={groundWaterChange}
                        style={{ width: "80px" }}
                        name="groundWaterPercentage"
                        value={groundWaterPercentage}
                        maxLength="3"
                        pattern="[\d]{1,3}"
                        required
                        className="w-100"
                      />
                      <Form.Control.Feedback type="invalid">
                        {groundWaterPercentage === EMPTY
                          ? ENTER_VALUE
                          : INVALID_VALUE}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Row>
                </div>
              )}
            </div>
            <Button
              type="submit"
              id="addFieldBtn"
              className="btnFieldDetails"
              disabled={btnAddFieldClick ? true : false}
            >
              {btnAddFieldClick === true ? (
                <div>
                  <Spinner
                    as="span"
                    animation="grow"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />{" "}
                  <span>
                    {editField || editRegisteredField
                      ? "Updating..."
                      : { btnClaimEnabled }
                      ? "Claiming..."
                      : "Adding..."}
                  </span>
                </div>
              ) : btnClaimEnabled ? (
                "Make A Claim"
              ) : editField || editRegisteredField ? (
                "Update"
              ) : (
                "Add"
              )}
            </Button>{" "}
            {editRegisteredField ? (
              <Button
                className="btnFieldDetails"
                onClick={(event) => hideShowPopup(event)}
              >
                {"Close"}
              </Button>
            ) : (
              EMPTY
            )}
          </Form>
        </Popover.Body>
      </div>
      <div
        id="add_farm"
        className={display_form === SHOW_FARM ? EMPTY : "hide-form"}
      >
        <Popover.Header>Add Farm</Popover.Header>
        <CloseButton
          className="close"
          variant="white"
          onClick={(event) => hideShowPopup(event)}
        />
        <Popover.Body>
          {farmError ? (
            <Alert
              key="messageAlert"
              variant={DANGER}
              closeAlert={(e) => closeAlert(e)}
              alertMessage={errorMessage}
              dismissible
            />
          ) : (
            EMPTY
          )}
          <Form
            key="popoverForm"
            noValidate
            validated={farmValidated}
            onSubmit={(e) => handle_add_farm(e)}
          >
            <Row>
              <Form.Group as={Col} controlId="validationMasterFarmName">
                <Form.Label>
                  Farm Name<span>*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  maxLength="40"
                  name="newFarmName"
                  required
                  value={newFarmName}
                  onChange={onChange}
                  className={
                    invalidFarmNameError ? "is-invalid invalidcontrol" : EMPTY
                  }
                />
                <Form.Control.Feedback type="invalid">
                  {newFarmName === EMPTY ? ENTER_FARM_NAME : FARM_NAME_EXIST}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group
                as={Col}
                controlId="validationBusinessName"
                className="p-0"
              >
                <Form.Label>
                  Business Name<span>*</span>
                </Form.Label>
                <Form.Select
                  required
                  onChange={handle_business_change}
                  value={businessName}
                >
                  <option value={EMPTY}>-- Select a Business --</option>
                  {business_list}
                </Form.Select>
                <Form.Control.Feedback type="invalid">
                  {SELECT_BUSINESS}
                </Form.Control.Feedback>
              </Form.Group>
              <Col className="col-1 ps-1">
                <i
                  className="fa fa-plus-circle add-farm-business-registration-btn"
                  onClick={add_new_business}
                />
              </Col>
            </Row>
            <Button type="submit" className="mt-2" disabled={btnAddFarmClick}>
              {btnAddFarmClick ? (
                <div>
                  <Spinner
                    as="span"
                    animation="grow"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />{" "}
                  <span>Adding...</span>
                </div>
              ) : (
                "Add"
              )}
            </Button>
          </Form>
        </Popover.Body>
      </div>
      <div
        id="add_business"
        className={display_form === SHOW_BUSINESS ? EMPTY : "hide-form"}
      >
        <Popover.Header>Add Business</Popover.Header>
        <CloseButton
          className="close"
          variant="white"
          onClick={(event) => hideShowPopup(event)}
        />
        <Popover.Body>
          {businessError ? (
            <Alert
              key="messageAlert"
              variant={DANGER}
              closeAlert={(e) => closeAlert(e)}
              alertMessage={errorMessage}
              dismissible
            />
          ) : (
            EMPTY
          )}
          <Form
            key="popoverForm"
            noValidate
            validated={businessValidated}
            onSubmit={(e) => handle_add_business(e)}
          >
            <Row>
              <Form.Group
                as={Col}
                md="6"
                controlId="validationMasterBusinessName"
                className=" pb-2"
              >
                <Form.Label>
                  Business Name<span>*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="newBusinessName"
                  maxLength="40"
                  required
                  value={newBusinessName}
                  onChange={onChange}
                  className={
                    invalidBusinessNameError
                      ? "is-invalid invalidcontrol"
                      : EMPTY
                  }
                />
                <Form.Control.Feedback type="invalid">
                  {newFarmName === EMPTY
                    ? ENTER_BUSINESS_NAME
                    : BUSINESS_NAME_EXIST}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group as={Col} md="6" className="mt-1">
                <Button
                  type="submit"
                  className="mt-3"
                  disabled={btnAddBusinessClick}
                >
                  {btnAddBusinessClick ? (
                    <div>
                      <Spinner
                        as="span"
                        animation="grow"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />{" "}
                      <span>Adding...</span>
                    </div>
                  ) : (
                    "Add"
                  )}
                </Button>
              </Form.Group>
            </Row>
          </Form>
        </Popover.Body>
      </div>
    </div>
  );
}

export default AddField;
